import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../../common';
import { Ng2DatetimePickerModule } from 'ng2-datetime-picker';
import NotFound from './not-found.component';

import DPSDashboardVC from './dashboard/dps-dashboard-vc.component';
import DPSManageVC from './manage/dps-manage-vc.component';
import InventoryTreeHolder from './dataprotection-tree/tree-holder/tree-holder.component';
import InventoryTreeVC from './dataprotection-tree/tree-vc/tree-vc.component';

import DataProtectionVC from './dataprotection-vc.component';
import { DpsVcService } from './dashboard/dps-dashboard-vc.service';

import { ContentModule } from './manage/content-switcher/content.module';
import DPSManageContent  from './manage/dps-manage-vc.component';
import { DataPasserService } from './manage/shared/data-passer.service';
import { DpsDeletedVmService } from './deleted-vms/deleted-vms.service';
import { DpsDeletedVmsModule } from './deleted-vms/deleted-vms.module';
import { ResizableModule } from 'angular-resizable-element';

@NgModule({
    declarations: [
        DataProtectionVC,
        DPSManageVC,
        DPSDashboardVC,
        InventoryTreeHolder,
        InventoryTreeVC,
        NotFound,
        DPSManageContent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        FormsModule,
        VcaCommonModule,
        TranslateModule,
        ClarityModule,
        Ng2DatetimePickerModule,
        ContentModule.forRoot(),
        DpsDeletedVmsModule,
        ResizableModule
    ],
    providers: [
        DataPasserService,
        DpsVcService,
        DpsDeletedVmService
    ],
    exports: [
        DataProtectionVC
    ]

})
export class DpsVcModule {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/dataprotection-vc.module.ts